import { render, staticRenderFns } from "./QuestionCardIndex.vue?vue&type=template&id=78b1c825&scoped=true&"
import script from "./QuestionCardIndex.vue?vue&type=script&lang=js&"
export * from "./QuestionCardIndex.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCardIndex.vue?vue&type=style&index=0&id=78b1c825&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b1c825",
  null
  
)

export default component.exports